import { forwardRef } from "react"

const Hidden = forwardRef(function Hidden({...props}, ref) {
  return (
    <input type="hidden" ref={ref} {...props}/>
  )
})

export default Hidden;
